import { Protocol } from "./Protocol";

export class getProtocolById {
    _id:number;
    name: string;
    Protocol:Protocol[]
    }